<script>
import cloneDeep from 'lodash/cloneDeep'
import { request } from '@/src/services'
import formatDate from '@utils/format-date'
import chartDateListRangeType from '@utils/chartDateListRangeType'
import {TIME_SELECT, UNIT} from '@utils/constant'
import { selectItemHistory, selectInformation } from './selectItemHistory'
import { kilogram, percent } from './checkboxItemHistory'
import configChart from './configChart'
import List from './list.vue'
export default {
  components: {List},
  props: {
    triggerMask: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      selectInformation: cloneDeep(selectInformation),
      selectItemHistory: cloneDeep(selectItemHistory),
      editable: false,
      configChart: cloneDeep(configChart),
      kilogram: cloneDeep(kilogram),
      percent: cloneDeep(percent),
      activeCheckbox: true,
      measure_chart_date: new Date(),
      selectChart: {
        day: '0',
        range: '1',
        item: 'kg',
      },
      keyList: this.kilogram,
      chart_colur_list : {
        体重: '#f86c6b',
        除脂肪体重: '#20a8d8',
        総筋肉量:'#4dbd74',
        骨量: '#ffc107',
        体脂肪率: '#f86c6b',
        皮下脂肪:'#20a8d8',
        体水分率:'#4dbd74',
        骨格筋:'#ffc107',
        タンパク質:'#6f42c1',
        BMI: '#f86c6b',
        体内年齢: '#f86c6b',
        内臓脂肪: '#f86c6b',
        基礎代謝: '#f86c6b',
      },
      chartData: null,
      endDate: null,
      startDate: null,
      switchChange: true,
      nowDate: null,
    }
  },
  computed: {
    chartDataComputed() {
      return this.handleGetChartData()
    }
  },
  created() {
    this.nowDate = formatDate(new Date())
    this.selectCheckbox()
    this.selectChartType()
  },
  methods: {
    selectChartType() {
      request({
        endpoint: '/cms/measure/charts/',
        payload: {
          member_id: parseInt(this.$route.params.id),
          day_type: parseInt(this.selectChart.day),
          range_type: parseInt(this.selectChart.range),
          end_date: this.nowDate,
        },
      }).then((res) => {
        if (res.data) {
          this.chartData = res.data
          this.startDate = res.data_start
          this.endDate = res.data_end
        }
      })
    },
    selectCheckbox() {
      this.keyList = []
      const keyList = []
      switch(this.selectChart.item) {
        case 'kg':
          this.kilogram.forEach(element => {
            if(element.value) {
              keyList.push({
                key: element.key,
                value: element.label,
              })
            }
          })
          break
        case 'percent':
          this.percent.forEach(element => {
            if(element.value) {
              keyList.push({
                key: element.key,
                value: element.label,
              })
            }
          })
          break
        case 'BMI':
          keyList.push({
            key: 'BMI',
            value: 'BMI',
          })
          break
        case 'metabolic_age':
          keyList.push({
            key: 'metabolic_age',
            value: '体内年齢',
          })
          break
        case 'visceral_fat':
          keyList.push({
            key: 'visceral_fat',
            value: '内臓脂肪',
          })
          break
        case 'BMR':
          keyList.push({
            key: 'BMR',
            value: '基礎代謝',
          })
          break
        default:
          break
      }
      this.keyList = keyList
    },
    handleGetChartData() {
      const chartDateset = []
      this.configChart.options.scales.xAxes[0].time.unit = 'day'
      this.configChart.options.scales.xAxes[0].ticks.source = 'labels'
      for(const key in this.keyList) {
        const data = [];
        for (const i in this.chartData) {
          const label = this.chartData.[i].label
          const values = this.chartData[i].value

        if (parseInt(values[this.keyList[key].key]) !== 0) {
          data.push({
            x: label,
            y: values[this.keyList[key].key],
          })
        }
      }
      data.sort(function(a,b){
          return new Date(b.x) - new Date(a.x);
        })
        chartDateset.push({label:this.keyList[key].value,
            data: data,
            fill:false,
            backgroundColor: this.chart_colur_list[this.keyList[key].value],
            borderColor: this.chart_colur_list[this.keyList[key].value],
            })
        }
      if (this.selectChart.range === TIME_SELECT.week) {
        this.configChart.options.scales.xAxes[0].ticks.source = 'labels'
      } else if (this.selectChart.range === TIME_SELECT.month) {

        this.configChart.options.scales.xAxes[0].ticks.source = 'labels'
        this.configChart.options.scales.xAxes[0].time.unit = 'month'
      }
      this.configChart.data.datasets = chartDateset

      this.configChart.data.labels = chartDateListRangeType(
        parseInt(this.selectChart.range),
        this.startDate,
        this.endDate
      )

      this.configChart.options.tooltips.callbacks = {
        label: function(tooltipItems, data) {
          const unit = UNIT.find(obj => obj.name === data.datasets[tooltipItems.datasetIndex].label)
            return (
              data.datasets[tooltipItems.datasetIndex].label
                + ': ' + tooltipItems.yLabel + ' ' + unit?.unit
            )
        },
      }

      return this.configChart
    },
    fetchChart(date) {
      this.nowDate = date
      this.selectChartType()
    },
    switchChart() {
      this.switchChange = true
    },
    switchTable() {
      this.switchChange = false
    },
  },
}
</script>

<template>
  <div>
    <BaseCardDetail form-collapsed title="計測履歴" :trigger-mask="triggerMask">
      <template v-slot:header-action>
        <CDropdown placement="bottom-end">
          <template v-slot:toggler>
            <CButton>
              <CIcon name="cilSettings" />
            </CButton>
          </template>
          <CDropdownItem class="border-bottom" @click="switchChart"
            >グラフ</CDropdownItem
          >
          <CDropdownItem @click="switchTable">一覧</CDropdownItem>
        </CDropdown>
      </template>
      <CRow v-if="switchChange">
        <CCol sm="3">
          <CRow
            v-for="(item, index) in selectItemHistory"
            :key="index + item.key"
          >
            <CCol sm="5">
              {{ item.label }}
            </CCol>
            <CCol sm="7">
              <BaseSelect
                :options="item.options"
                :placeholder="selectChart[item.key]"
                :value.sync="selectChart[item.key]"
                @update:value="selectChartType"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="5">
              {{ selectInformation.label }}
            </CCol>
            <CCol sm="7">
              <BaseSelect
                :options="selectInformation.options"
                placeholder="Kg"
                :value.sync="selectChart.item"
                @update:value="selectCheckbox"
              />
            </CCol>
          </CRow>

          <template v-if="selectChart.item === 'kg'">
            <CRow v-for="(item, index) in kilogram" :key="index" class="ml-5">
              <CInputCheckbox
                :label="item.label"
                :checked.sync="item.value"
                @update:checked="selectCheckbox"
              />
            </CRow>
          </template>

          <template v-if="selectChart.item === 'percent'">
            <CRow v-for="(item, index) in percent" :key="index" class="ml-5">
              <CInputCheckbox
                :label="item.label"
                :checked.sync="item.value"
                @update:checked="selectCheckbox"
              />
            </CRow>
          </template>
        </CCol>
        <CCol sm="9">
          <CChartLine
            style="height:400px"
            :datasets="chartDataComputed.data.datasets"
            :labels="chartDataComputed.data.labels"
            :options="chartDataComputed.options"
          />
          <BaseSwitchTimeChart
            :end-date="endDate"
            :range="selectChart.range"
            @getDate="fetchChart"
          />
        </CCol>
      </CRow>
      <CRow v-else>
        <CCol sm="12">
          <List />
        </CCol>
      </CRow>
    </BaseCardDetail>
  </div>
</template>
